// apiBaseUrl vacío = rutas relativas (usa el proxy de Vite en dev y un
// reverse proxy común en prod). Si se declara absoluto, axios lo usa tal cual.
export const env = {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
    appName: import.meta.env.VITE_APP_NAME ?? 'SSC',
    appVersion: import.meta.env.VITE_APP_VERSION ?? '0.0.0',
    isProd: import.meta.env.PROD,
    isDev: import.meta.env.DEV,
};
